















import { Component, Watch } from 'vue-property-decorator';
import { mixins } from 'vue-class-component';

import ChangePlanDialog from '@/views/settings/subscription/forms/change-plan/change-plan.vue';

import UnpaidInvoicesDialog from './dialogs/unpaid-invoices-dialog/unpaid-invoices-dialog.vue';

import subscriptionApi, { SubscriptionApi } from '@/views/settings/subscription/api';
import UserApi from '@/services/rest/bemob/user';
import { AppErrorEnum } from '@/services/models/Enums';
import PaymentStatusMixin from '@/views/layout/navigation/mixins/payment-status-mixin';
import FreeEventsLimit from '@/components/app-exceptions-resolver/dialogs/free-events-limit.vue';
import EventsLimitNotice from '@/components/app-exceptions-resolver/dialogs/events-limit-notice.vue';
import PendingInvoiceGeneration from '@/components/app-exceptions-resolver/dialogs/pending-invoice-generation.vue';

@Component({
  components: {
    PendingInvoiceGeneration,
    FreeEventsLimit,
    EventsLimitNotice,
    UnpaidInvoicesDialog,
    ChangePlanDialog
  },
})
export default class AppExceptionsResolver extends mixins(PaymentStatusMixin) {
    subscriptionApi: SubscriptionApi = subscriptionApi;
    userApi: UserApi = new UserApi();
     
    get isPanelBlocked() {
      return !!(this.isLimitError || this.isUnpaidInvoicesError || this.$store.state.user?.blockedCampaigns);
    }

    get isLimitError() {
      return this.$store.state.appError === AppErrorEnum.freePlanLimitsExceeded
        && !this.$store.state.user?.pendingInvoiceGeneration;
    }

    get isPendingInvoiceGeneration() {
      return this.$store.state.user?.pendingInvoiceGeneration;
    }
      
    get isUnpaidInvoicesError() {
      return this.$store.state.appError === AppErrorEnum.unpaidInvoices; 
    }

    @Watch('isPanelBlocked', { immediate: true })
    onIsPanelBlockedChanged(value: boolean) {
      this.$store.commit('panelBlocked', value);
    }
}
